import React, { useState, useEffect } from 'react';
import '../styles/Footer.css';

export function Footer() {
  const [footerLinks, setFooterLinks] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch footer links
    fetch('/api/footer')
      .then(res => res.json())
      .then(data => {
        if (data.success && data.links) {
          // Group links by section
          const grouped = {};
          data.links.forEach(link => {
            if (!grouped[link.section_name]) {
              grouped[link.section_name] = [];
            }
            grouped[link.section_name].push(link);
          });
          
          // Sort links within each section by sort_order
          Object.keys(grouped).forEach(section => {
            grouped[section].sort((a, b) => a.sort_order - b.sort_order);
          });
          
          setFooterLinks(grouped);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching footer links:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return null;
  }

  return (
    <footer className="footer bg-dark text-light py-5 mt-5">
      <div className="container">
        <div className="row">
          {Object.keys(footerLinks).map(section => (
            <div key={section} className="col-md-6 col-lg-3 mb-4">
              <h6 className="footer-section-title fw-bold mb-3">{section}</h6>
              <ul className="footer-links list-unstyled">
                {footerLinks[section].map(link => (
                  <li key={link.id} className="mb-2">
                    <a 
                      href={link.link_url} 
                      target={link.target === '_blank' ? '_blank' : '_self'}
                      rel={link.target === '_blank' ? 'noopener noreferrer' : ''}
                      className="footer-link text-light text-decoration-none"
                    >
                      {link.link_text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <hr className="bg-light" />
        
        <div className="row mt-4">
          <div className="col-md-6">
            <p className="text-muted small mb-0">
              &copy; {new Date().getFullYear()} Alo@laba Festival. All rights reserved.
            </p>
          </div>
          <div className="col-md-6 text-md-end">
            <p className="text-muted small mb-0">
              Powered by <a href="https://makeitservices.org" target="_blank" rel="noopener noreferrer" className="text-light">Make It Services</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
